import { CardTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/CardTab/CardTab';
import { IActiveTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/TabsSection/TabsSection';
import { IRecommendationCardPayload } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/RecommendationCardModal/RecommendationCardModal.utils.types';
import { TabItem } from 'components/DesignSystem/Tabs';

export const tabsArrData: TabItem[] = [
    {
        value: 'cardDetails',
        label: 'Card Details',
    },
    {
        value: 'relatedCards',
        label: 'Associated Activities',
    },
    {
        value: 'auditLogs',
        label: 'Audit Log',
    },
];

export const buildRecommendationCardPayload = (data): IRecommendationCardPayload => {
    return {
        id: data.id,
        projectId: data.project.id,
        contractId: data.contract.id,
        activityId: data.activityId,
        assigneeUserName: data.assignee.value,
        category: data.category.value,
        details: data.details,
        mentionedList: data.mentionedList,
        startDate: data.startDate,
        endDate: data.endDate,
        externalLinks: data.externalLinks,
        status: data.status.name,
        title: data.title,
        relatedCardIds: null,
        type: data.type,
        isImportant: data.isImportant,
        versionId: data.versionId,
    };
};
